import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Inline, Checkbox, Text, TooltipRenderer, Box, IconHelp, Columns, Column, Divider } from "braid-design-system";
import { translations } from "../../../../private/components/JobAccessFormHeader/.vocab/index.mjs";
import { headerContainer } from "./index.css.mjs";
const HeaderWithCheckbox = ({
  id,
  ariaLabel,
  checked,
  text,
  onChange,
  tooltipText
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.currentTarget.checked);
    }
  };
  return /* @__PURE__ */ jsxs(Inline, { space: "xxsmall", children: [
    checked.length === 0 ? null : /* @__PURE__ */ jsx(
      Checkbox,
      {
        id,
        label: "",
        "aria-label": ariaLabel,
        checked,
        onChange: handleChange
      }
    ),
    /* @__PURE__ */ jsx(Text, { weight: "strong", baseline: false, children: text }),
    /* @__PURE__ */ jsx(
      TooltipRenderer,
      {
        id: `${id}-tooltip`,
        placement: "bottom",
        tooltip: /* @__PURE__ */ jsx(Text, { children: tooltipText }),
        children: ({ triggerProps }) => /* @__PURE__ */ jsx(Box, { ...triggerProps, children: /* @__PURE__ */ jsx(Text, { baseline: false, children: /* @__PURE__ */ jsx(IconHelp, {}) }) })
      }
    )
  ] });
};
const JobAccessFormHeader = ({
  id,
  isSelectAllJobAccessChecked,
  isSelectAllNotifyChecked,
  onSelectAllJobAccess,
  onSelectAllNotify
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: headerContainer,
      background: "surface",
      zIndex: "sticky",
      children: [
        /* @__PURE__ */ jsx(Box, { paddingX: "small", paddingY: "small", children: /* @__PURE__ */ jsxs(Columns, { space: "small", children: [
          /* @__PURE__ */ jsx(Column, { width: "1/4", children: /* @__PURE__ */ jsx(Text, { weight: "strong", baseline: false, children: t("Name") }) }),
          /* @__PURE__ */ jsx(Column, { width: "1/3", children: /* @__PURE__ */ jsx(Text, { weight: "strong", baseline: false, children: t("Email") }) }),
          /* @__PURE__ */ jsx(Column, { width: "1/5", children: /* @__PURE__ */ jsx(
            HeaderWithCheckbox,
            {
              id: `${id}-job-access-checkbox-all`,
              ariaLabel: t("Select to give job access to all team members"),
              text: t("Access"),
              tooltipText: t(
                "Give team members access to view and manage applications for the job."
              ),
              checked: isSelectAllJobAccessChecked,
              onChange: onSelectAllJobAccess
            }
          ) }),
          /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(
            HeaderWithCheckbox,
            {
              id: `${id}-job-notify-checkbox-all`,
              ariaLabel: t("Select to notify all team members"),
              text: t("Send Invite"),
              tooltipText: t("Email team members an invitation to the job."),
              checked: isSelectAllNotifyChecked,
              onChange: onSelectAllNotify
            }
          ) })
        ] }) }),
        /* @__PURE__ */ jsx(Divider, {})
      ]
    }
  );
};
export {
  JobAccessFormHeader
};
